"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressRadial = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../../utils/index.js");
require("@itwin/itwinui-css/css/progress-indicator.css");
/**
 * Circular Progress Indicator
 * @example
 * Basic
 * <ProgressRadial value={50} />
 * Indeterminate
 * <ProgressRadial indeterminate />
 * Positive / Negative
 * <ProgressRadial status='positive' />
 * <ProgressRadial status='negative' />
 * Centered Content
 * <ProgressRadial value={63}>63</ProgressRadial>
 * Small
 * <ProgressRadial size={'small'} indeterminate/>
 */
const ProgressRadial = (props) => {
    const { value = 0, indeterminate = false, status, children, size = '', className, style, ...rest } = props;
    (0, index_js_1.useTheme)();
    const statusMap = {
        negative: React.createElement(index_js_1.SvgImportantSmall, { "aria-hidden": true }),
        positive: React.createElement(index_js_1.SvgCheckmarkSmall, { "aria-hidden": true }),
    };
    const fillStyle = {
        strokeDashoffset: status === 'positive'
            ? 0
            : 88 -
                Math.min(88, Math.max(0, indeterminate ? 88 : (88 * value) / 100)),
    };
    return (React.createElement("div", { className: (0, classnames_1.default)('iui-progress-indicator-radial', {
            'iui-determinate': !indeterminate,
            'iui-indeterminate': indeterminate,
            [`iui-${size}`]: !!size,
            [`iui-${status}`]: !!status,
        }, className), style: style, ...rest },
        React.createElement("svg", { className: 'iui-radial', viewBox: '0 0 32 32', "aria-hidden": 'true' },
            React.createElement("circle", { className: 'iui-track', cx: '16', cy: '16', r: '14' }),
            React.createElement("circle", { className: 'iui-fill', cx: '16', cy: '16', r: '14', style: fillStyle })),
        React.createElement(React.Fragment, null,
            status && (React.createElement("span", { className: 'iui-inner-content' }, statusMap[status])),
            !status && children && (React.createElement("span", { className: 'iui-inner-content' }, children)))));
};
exports.ProgressRadial = ProgressRadial;
exports.default = exports.ProgressRadial;
